import { render, staticRenderFns } from "./NtnCertificatePrint.vue?vue&type=template&id=bb5d14e4&scoped=true&"
import script from "./NtnCertificatePrint.vue?vue&type=script&lang=js&"
export * from "./NtnCertificatePrint.vue?vue&type=script&lang=js&"
import style0 from "./NtnCertificatePrint.vue?vue&type=style&index=0&id=bb5d14e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5d14e4",
  null
  
)

export default component.exports